const BRAZILIAN_NATIONALITY_IDS = [ 10 ]

export const isNotForeign = ({ nationalities = [] } = {}) =>
  !nationalities.length
  || nationalities.findIndex((id) => BRAZILIAN_NATIONALITY_IDS.includes(id)) >= 0
